import React, { useContext } from 'react';
import { UserOrderContext } from 'context/context';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import Selection_Customize from 'styles/staticAssets/images/Selection_Customize.svg';
import ImageComponent from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import PRODUCT_CUSTOM_CONSTANTS from 'organisms/ProductListingCustomizationComponent/Constants/CustomizationConstants';
import {
  getAndCheck,
  getLength,
  getValueByKeyName,
  getTernaryValue,
  checkAllTrue,
  getMainImagePath,
  isCateringDisposition,
} from 'common/utilities/utils';
import { getButtonText } from 'organisms/ProductListingModalOptions/AU/Presentation/ModifierCard';
import { FREE, priceFixed_value } from 'common/constants/SharedConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { ReactSVG } from 'react-svg';
import QuantityModifier from 'molecules/QuantityModifier/AU/Container/QuantityModifier';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const getPriceText = (price, currencySymbol, toRenderCheckBox) => {
  let signedPrice = getTernaryValue(
    price < 0,
    `-${currencySymbol}${Math.abs(price).toFixed(priceFixed_value)} `,
    `+${currencySymbol}${price} `,
  );
  return Number(price) !== 0.0
    ? getTernaryValue(toRenderCheckBox, signedPrice, `${currencySymbol}${price}`)
    : getTernaryValue(toRenderCheckBox, '', translateWithI18Next(FREE));
};

const onSaveProductHandler = (event, localized, isStoreClosed, onSaveProduct, toRenderCheckBox) => {
  if (checkAllTrue([localized, !isStoreClosed, toRenderCheckBox])) {
    onSaveProduct();
  } else {
    event.preventDefault();
    event.stopPropagation();
  }
};

const checkPriceAvailability = (price, priceText) => getAndCheck(price !== undefined, getLength(priceText) > 0);

export const getCaloriesPriceTemplate = priceCalObj => {
  const { calories, kilojoule, price, currencySymbol, toRenderCheckBox, modgrpMax } = priceCalObj;
  const toRenderFlag = !toRenderCheckBox || (toRenderCheckBox && modgrpMax > 1) ? false : true;
  const priceText = getPriceText(price, currencySymbol, toRenderFlag);
  const pricetemplate = price !== undefined && <span className='caloricInfo'>{priceText}</span>;
  const calorifictemplateWithPrice = (
    <span className='caloricInfo calorificWithPrice'>{` ${calories} ${kilojoule}`}</span>
  );
  const calorifictemplateWithoutPrice = <span className='caloricInfo'>{` ${calories} ${kilojoule}`}</span>;
  const calorifictemplate = calories ? (
    (checkPriceAvailability(price, priceText) && calorifictemplateWithPrice) || calorifictemplateWithoutPrice
  ) : (
    <></>
  );
  return (
    <div>
      {pricetemplate}
      {calorifictemplate}
    </div>
  );
};
const ModifierCardTemplate = props => {
  const {
    onSaveProduct,
    imageContainerSize,
    defaultImagePath,
    selectedProduct,
    price,
    isMobile,
    cardData,
    modgrpData,
    kilojoule,
    isStoreClosed,
    customizeClickHandler,
    localized,
    showButton,
    currencySymbol,
    updateItemQuantity,
    itemCount,
    isModgrpMax,
    toRenderCheckBox,
    toRenderQuantityModifier,
    dispositionType,
    handleCateringModifierQuantity,
    itemCountShouldAtModifierLevel,
    savedCustomizedModifier,
  } = props;
  const { modgrpId, max: modgrpMax, comboL2 = false, modifierLength } = modgrpData;
  const { id, dname, isHidden, content, modgrps, isExcluded, defaultQuantity } = cardData;
  const dName = getLength(dname) && dname[0]?.value;
  const calories = content?.caloricValue;
  const { userOrderState } = useContext(UserOrderContext);
  const { pdpPayloadData } = userOrderState;

  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { ITEM_QUANTITY } = PRODUCT_CUSTOM_CONSTANTS;
  const { PEROPTIONMAX_KEY,PEROPTIONMIN_KEY } = MENU_PDP_PAGE_CONSTANTS;
  const selectedTickImage = modgrpMax > 1 ? IMAGE_PATH.Multiselect_Check_Icon : IMAGE_PATH.Check_Icon;
  const unselectedTickImage = modgrpMax > 1 ? IMAGE_PATH.Multiselect_Uncheck_Icon : IMAGE_PATH.Selection_Checkbox_off;
  const imagePath = getMainImagePath(content, imageContainerSize, imageContainerSize);
  const tickTemplate = checkAllTrue([
    isCateringDisposition(dispositionType),
    modifierLength === 1,
    modgrps?.length === 0,
  ]) ? (
    <></>
  ) : (
    <picture className='sopac-modifier-card-tick'>
      <source
        media='(max-width: 1023px)'
        srcSet={((selectedProduct && !isExcluded) && selectedTickImage) || unselectedTickImage}
        alt={((selectedProduct && !isExcluded) && 'checked') || ''}
      />
      <img
        src={((selectedProduct && !isExcluded) && selectedTickImage) || unselectedTickImage}
        alt={(selectedProduct && 'checked') || ''}
      />
    </picture>
  );
  const imageTemplate = imagePath ? (
    <ImageComponent defaultPath={defaultImagePath} srcFile={imagePath} className='sopac-modifier-card-image' />
  ) : (
    <></>
  );
  const titleTemplate = () => {
    const priceCalObj = { comboL2, calories, kilojoule, price, currencySymbol, toRenderCheckBox, modgrpMax };
    const caloriesPriceTemplate = getCaloriesPriceTemplate(priceCalObj);
    return (
      <div className='sopac-modifier-card-name' tabIndex='0'>
        <div className='title'>{dName}</div>
        {isExcluded ? productUnavailableText() : caloriesPriceTemplate}
      </div>
    );
  };
  const productUnavailableText = () => {
    return (
      <div className='unavailable-container'>
        <ReactSVG src={IMAGE_PATH.TimerIcon} className='unavailable-icon' />
        <div className='unavailable-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.CURRENTLY_UNAVAILABLE)}</div>
      </div>
    );
  };
  const getMobileCardView = () => {
    return (
      <>
        <div className='sopac-modifier-wrapper'>
          {checkAllTrue([localized, toRenderCheckBox, !isStoreClosed]) && tickTemplate}
          {titleTemplate()}
        </div>
        {imageTemplate}
      </>
    );
  };

  const getDesktopCardView = () => {
    return (
      <>
        {checkAllTrue([localized, toRenderCheckBox, !isStoreClosed]) && tickTemplate}
        {imageTemplate}

        {titleTemplate()}
      </>
    );
  };

  const getCustomizedButtonComp = () => {
    return (
      <div className='sopac-modifier-customizeblock'>
        <ButtonComp
          ariaLable='customize'
          data-testid='customize-btn'
          className='deepBlack font-bold customize-btn button blackBorder'
          disabled={!selectedProduct || isExcluded}
          onClick={event => customizeClickHandler(event, id, modgrpId)}
        >
          {getButtonText(cardData, modgrpId, pdpPayloadData)}
          <ImageComponent
            className={`customize-icon ${getTernaryValue(!selectedProduct, 'disabled-icon', '')}`}
            srcFile={Selection_Customize}
          />
        </ButtonComp>
      </div>
    );
  };
  const maxItemCountPerLineItem = getTernaryValue(
    itemCountShouldAtModifierLevel,
    getValueByKeyName(cardData?.additionalProperties, PEROPTIONMAX_KEY),
    getValueByKeyName(modgrpData?.additionalProperties, PEROPTIONMAX_KEY),
  );
  const minItemCountPerLineItem = itemCountShouldAtModifierLevel?
    getValueByKeyName(cardData?.additionalProperties, PEROPTIONMIN_KEY):
    getValueByKeyName(modgrpData?.additionalProperties, PEROPTIONMIN_KEY)

  const getQtyModifierComp = () => {
    return checkAllTrue([isCateringDisposition(dispositionType), modifierLength === 1, modgrps?.length === 0]) ? (
      <></>
    ) : (
      <div className={`sopac-modifier-customizeblock ${getAndCheck(isModgrpMax, 'modgrp-greyout')}`}>
        <QuantityModifier
          itemCount={itemCount}
          itemQuantity={ITEM_QUANTITY}
          updateItemQuantity={updateItemQuantity}
          quantityAction={QUANTITY_ACTION}
          item={undefined}
          itemName={dName}
          defaultQuantity={defaultQuantity}
          maxItemCountPerLineItem={maxItemCountPerLineItem}
          cartItemCount={1}
          hideChild={true}
          type='button'
          dispositionType={dispositionType}
          handleQuantityForCatering={handleCateringModifierQuantity}
          inputType='number'
          modgrpMax={modgrpMax}
          savedCustomizedModifier={savedCustomizedModifier}
          minItemCountPerLineItem={minItemCountPerLineItem}
        />
      </div>
    );
  };

  const mobileCardView = isMobile && getMobileCardView();
  const desktopCardView = !isMobile && getDesktopCardView();

  return (
    !isHidden && (
      <div className={`sopac-modifier ${getTernaryValue(isExcluded, 'sopac-modifier-deactive')}`}>
        <div
          className='sopac-modifier-card d-flex'
          data-testid='click-save-product'
          onClick={event =>
            !isExcluded && onSaveProductHandler(event, localized, isStoreClosed, onSaveProduct, toRenderCheckBox)
          }
        >
          {mobileCardView}
          {desktopCardView}
        </div>
        {showButton ? getCustomizedButtonComp() : null}
        {checkAllTrue([localized, toRenderQuantityModifier, !isStoreClosed, !isExcluded]) && getQtyModifierComp()}
      </div>
    )
  );
};

export default ModifierCardTemplate;
